var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSorticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.525792 0.180003C0.167699 0.180003 -0.0543983 0.55897 0.127238 0.859515L5.14974 7.38317V12.335C5.14974 12.6698 5.51146 12.8873 5.81897 12.7376L7.66844 11.8372C7.82504 11.7608 7.92376 11.6051 7.92376 11.4345V7.38286L12.9463 0.8592C13.1283 0.559015 12.9062 0.179688 12.5477 0.179688L0.525792 0.180003ZM1.33619 1.08047H11.7375L7.06295 7.03104C7.02087 7.10032 6.99865 7.17955 6.99901 7.25991V11.1565L6.07409 11.6068V7.26C6.07409 7.17929 6.05187 7.1005 6.01015 7.03113L1.33619 1.08047Z",
    fill: "#778CA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorticon);
export default __webpack_public_path__ + "static/media/sorticon.1de398fa426b47702f042052bdcf2106.svg";
export { ForwardRef as ReactComponent };